<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    max-width="50%"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider :name="$t(dateName)" rules="required" v-slot="{ errors }">
        <v-text-field
          v-model="pickerDate"
          readonly
          v-on="on"
          :disabled="isAllTextFieldDisabled"
          @keyup.enter="keyupEnter"
          clearable
          :error-messages="errors[0]"
        >
          <template v-slot:label>
            <span class="red--text">
              <strong>* </strong>
            </span>
            {{ $t(dateName) }}
          </template>
        </v-text-field>
      </ValidationProvider>
    </template>
    <v-date-picker
      v-model="pickerDate"
      :locale="getLocale"
      @input="showPicker = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerSetTime',
  props: {
    dateName: {
      type: String
    },
    isAllTextFieldDisabled: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number
    }
  },
  data () {
    return {
      showPicker: false,
      pickerDate: null
    }
  },
  mounted () {
    if (this.time !== 0) {
      this.pickerDate = this.$moment(this.time).format('YYYY-MM-DD')
    }
  },
  computed: {
    getLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    keyupEnter (event) {
      this.showPicker = false
      this.$emit('keyupEnter', event)
    }
  },
  components: {},
  watch: {
    pickerDate (newVal) {
      let timestamp = ''
      if (newVal !== '' && newVal !== null) {
        timestamp = Date.parse(newVal + ' 00:00:00:000')
      } else {
        timestamp = 0
      }
      this.$emit('setDate', timestamp)
    },
    time (newVal) {
      if (newVal !== 0) {
        this.pickerDate = this.$moment(newVal).format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style></style>
